import React, { useEffect, useState } from "react";


export default function CountDownCard2() {
  const TARGET = "2026-12-31T23:59:59";

  const calc = () => {
    const diff = new Date(TARGET) - new Date();
    if (diff <= 0)
      return { d: 0, h: 0, m: 0, s: 0, expired: true };

    return {
      d: Math.floor(diff / (1000 * 60 * 60 * 24)),
      h: Math.floor((diff / (1000 * 60 * 60)) % 24),
      m: Math.floor((diff / (1000 * 60)) % 60),
      s: Math.floor((diff / 1000) % 60),
      expired: false
    };
  };

  const [time, setTime] = useState(calc());

  useEffect(() => {
    const timer = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (<>
    <section className="attack-offer-box">
      <h1>
        GET AT <span>40% </span>DISCOUNT
      </h1>

      <div className="timer-grid">
        <div><strong>{time.d}</strong><span>DAYS</span></div>
        <div><strong>{time.h}</strong><span>HOURS</span></div>
        <div><strong>{time.m}</strong><span>MINS</span></div>
        <div><strong>{time.s}</strong><span>SECS</span></div>
      </div>
<div>
      <button className="main-offer-btn">
        Secure Your Seat Rs. 1500 <span className="strike">Rs. 2500</span>
      </button>
</div><div>
    <button className="attack-btn">GET IT NOW</button>
</div>
      
    </section>
    <style>{`.attack-offer-box {
  background: #000;
  padding: 60px 30px;
  text-align: center;
  color: #fff;
  border: 10px solid #001432;
  border-radius: 0px;
  width: 100%;margin-top:50px;;margin-bottom:50px;
}

.attack-offer-box h1 {
  font-size: 34px;
  font-weight: 800;
}

.attack-offer-box h1 span {
  color: rgba(144, 202, 249,1);
}

.timer-grid {
  display: flex;
  justify-content: center;
  gap: 22px;
  margin: 40px 0;
}
.timer-grid  div span {  color: #000;}
.timer-grid div {
  background: rgba(144, 202, 249,1);
  width: 130px;
  height: 140px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(144, 202, 249,1);
}

.timer-grid strong {
  font-size: 46px;
  color: #000;
}

.timer-grid span {
  font-size: 13px;
  opacity: 0.8;
}

.main-offer-btn {
  background: linear-gradient(90deg, rgba(144, 202, 249,1), rgba(144, 202, 249,1));
  padding: 14px 28px;
  border-radius: 50px;
  font-size: 20px;
  color: #000;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  font-weight: 600;
}

.main-offer-btn .strike {
  text-decoration: line-through;
  font-size: 18px;
  margin-left: 10px;
  opacity: 0.6;
}

.attack-btn {
  background: transparent;
  color: rgba(144, 202, 249,1);
  padding: 12px 22px;
  font-size: 15px;
  margin-top: 18px;
  border: 1px solid rgba(144, 202, 249,1);
  border-radius: 6px;
  cursor: pointer;
}

@media(max-width: 768px) {
.attack-offer-box {border: 0px solid #001432;
  padding: 60px 0px;}
  .timer-grid { flex-wrap: wrap; }
  .timer-grid div {
    width: 110px;
    height: 120px;
  }
}
`}</style>
    </>
  );
}
